import { defineStore } from "pinia";

export const useToastStore = defineStore('toast', () => {
    const queue = ref([]);

  function error(message = '') {
    queue.value.push({message, color: 'error'});
  }

  function success(message = '') {
    queue.value.push({message, color: 'success'});
  }

  function warning(message = '') {
    queue.value.push({message, color: 'warning'});
  }

  return {
    queue, error, success, warning
  };
});
